import React, { useEffect, useCallback } from 'react';
import useDoctorScheduleStore from './useDoctorScheduleStore';
import FilterBar from './FilterBar';
import ScheduleLegend from './ScheduleLegend';
import WeeklyGridView from './WeeklyGridView';
import DoctorCardView from './DoctorCardView';
import CompactPagination from '../shared/CompactPagination';

function DoctorScheduleManagement({ translations }) {
  const fetchData = useDoctorScheduleStore((s) => s.fetchData);
  const viewMode = useDoctorScheduleStore((s) => s.viewMode);
  const filters = useDoctorScheduleStore((s) => s.filters);
  const pagination = useDoctorScheduleStore((s) => s.pagination);
  const setPage = useDoctorScheduleStore((s) => s.setPage);
  const setTranslations = useDoctorScheduleStore((s) => s.setTranslations);
  const paginationTranslations = translations.pagination || {};

  useEffect(() => {
    setTranslations(translations);
  }, [translations, setTranslations]);

  useEffect(() => {
    fetchData();
  }, [
    filters.hospital_id,
    filters.speciality_id,
    filters.day,
    filters.source,
    filters.has_schedule_only,
  ]);

  const handlePageChange = useCallback((page) => {
    setPage(page);
    setTimeout(() => fetchData(), 0);

    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [setPage, fetchData]);

  return (
    <div className="doctor-schedule-mgmt">
      <FilterBar translations={translations} />
      <ScheduleLegend translations={translations} />

      {viewMode === 'list' ? (
        <WeeklyGridView translations={translations} />
      ) : (
        <DoctorCardView translations={translations} />
      )}

      <CompactPagination
        className="mt-4"
        currentPage={pagination.current_page}
        totalPages={pagination.total_pages}
        totalCount={pagination.total_count}
        itemLabel={paginationTranslations.items}
        previousLabel={paginationTranslations.previous}
        nextLabel={paginationTranslations.next}
        onPageChange={handlePageChange}
        ariaLabel="Doctor schedule pagination"
      />
    </div>
  );
}

export default DoctorScheduleManagement;
